<template>
    <div class="cashier-withdraw">
        <div class="withdraw-section">
            <div class="section-title">
                <span>Crypto Withdrawals</span>
        
            </div>

            <CashierElement v-on:click.native="modalCryptoButton('btc')" type="crypto" method="btc" v-bind:enabled="true" />
            <CashierElement v-on:click.native="modalCryptoButton('eth')" type="crypto" method="eth" v-bind:enabled="true" />
            <CashierElement v-on:click.native="modalCryptoButton('ltc')" type="crypto" method="ltc" v-bind:enabled="true" />
        </div>

        <div v-if="depositTotal < 10" class="deposit-requirement-notice">
            <p>Withdrawals locked: You must deposit at least <strong>$10.00</strong> total.</p>
            <p>Your current total: <strong>${{ depositTotal.toFixed(2) }}</strong></p>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import CashierElement from '@/components/cashier/CashierElement';

    export default {
        name: 'CashierWithdraw',
        components: {
            CashierElement
        },
        methods: {
            ...mapActions([
                'modalsSetShow', 
                'modalsSetData',
                'notificationShow'
            ]),
            modalCryptoButton(currency) {
                // The Hardcoded $10 Check
                if (this.depositTotal < 10) {
                    this.notificationShow({ 
                        type: 'error', 
                        message: 'Error: You must deposit at least $10.00 total to withdraw.' 
                    });
                    return;
                }

                this.modalsSetShow(null);
                this.modalsSetData({ 
                    typeCashier: 'withdraw', 
                    currency: currency,
                    minWithdraw: 1.00 
                });

                setTimeout(() => { this.modalsSetShow('Crypto'); }, 200);
            }
        },
        computed: {
            ...mapGetters([
                'authUser',
                'generalSettings'
            ]),
            // This safely calculates the total so it NEVER crashes the UI
            depositTotal() {
                try {
                    return this.authUser.data.stats.deposit || 0;
                } catch (e) {
                    return 0;
                }
            }
        }
    }
</script>

<style scoped>
    .cashier-withdraw {
        width: 100%;
    }

    .cashier-withdraw .withdraw-section {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 15px;
    }

    .cashier-withdraw .section-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 700;
        color: #5191b1;
        margin-bottom: 10px;
    }

    .cashier-withdraw .min-limit {
        font-size: 12px;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.05);
        padding: 4px 10px;
        border-radius: 5px;
        opacity: 0.8;
    }

    .cashier-withdraw .deposit-requirement-notice {
        width: 100%;
        margin-top: 20px;
        padding: 15px;
        background: rgba(255, 73, 73, 0.1);
        border: 1px dashed rgba(255, 73, 73, 0.4);
        border-radius: 10px;
        color: #ff4949;
        text-align: center;
        font-size: 13px;
    }

    @media only screen and (max-width: 800px) {
        .cashier-withdraw .withdraw-section {
            justify-content: flex-start;
        }
    }
</style>